
export enum CarrierNoaStatus {
  Current = 'Current',
  Expired = 'Released',
  Pending = 'Pending',
}

export enum CarrierBadge {
  Current = 'Current',
  Expired = 'Released',
  Pending = 'Pending',
  NoNoa = 'No NOA',
  Superseded = 'Superseded',
}

export interface Carrier {
  carrierId: string;
  carrierName: string;
  mcNumber?: string;
  dotNumber?: string;
  status: CarrierNoaStatus;
  hasNoaDocument: boolean;
  isSuperseded?: boolean;
  lastUpdated?: string;
  issuedDate?: string;
  effectiveDate?: string;
}

export enum NoaDocumentType {
  Noa = 'NOA',
  Lor = 'LOR',
  Slor = 'SLOR',
}

export interface NoaDocument {
  documentId: string;
  documentName?: string;
  documentType?: string;
  version?: string;
  status?: string;
  issuedDate?: string;
  effectiveDate?: string;
  isLatest?: boolean;
  isDownloadable?: boolean;
}

export enum NoaJobStatus {
  New = 10,
  Processing = 20,
  Presenting = 21,
  Complete = 30,
  Errored = 31,
}

export interface NoaDocumentResponse {
  documentId: string;
  clientId: number;
  debtorId?: number;
  status: NoaJobStatus;
  type?: string;
  dateCreated: string;
  dateModified: string;
}

export interface CarrierNoaDetailResponse {
  carrier: Carrier;
  documents: NoaDocumentResponse[];
}

export interface CarrierNoaDetail {
  carrier: Carrier;
  documents: NoaDocument[];
}

export interface CarrierSearchResponse {
  results: Carrier[];
  totalResults?: number;
  currentPage?: number;
}
